const navTargets = {
  newMeasurement: '/startup',
  masurementsOverview: '/measurements_overview',
  account: '/account',
  login:'/'
};

export default navTargets;
